import { useMutation } from '@tanstack/react-query';

import { confirmEmail, resendConfirmationEmail } from '../services/email-verification.service';

export function useConfirmEmail() {
  return useMutation({ mutationFn: (token: string) => confirmEmail(token) });
}

export function useResendConfirmationEmail() {
  return useMutation({ mutationFn: () => resendConfirmationEmail() });
}
